export enum HistoricAction {
    published = 'Pub',
    create = 'Add',
    update = 'Update',
    unpublish = 'Unpub',
    archive = 'Archive'
}